import React, { Component } from 'react';
import Cookies from 'universal-cookie';
export const LanguageContext = React.createContext();
export class LanguageProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: {
                en: {
                    //collections
                    choose: 'Choose',
                    allcollections: 'Collections',
                    collectionname: 'Collection Name',
                    productsquantity: 'Products Quantity',
                    addcollection: 'Add Collection',
                    filesuploaded: 'File Uploaded',
                    imageuploadedsuccess: 'Image Upload Success',
                    servererroruploadingimage: 'Server Error in Uploading Image',
                    description: 'Description',
                    productname: 'Product Name',
                    add: 'Add',
                    remove: 'Remove',
                    draganddropfiles: 'Drag & Drop Files or Click To Browse',
                    uploadlogo: 'Upload logo',
                    nocollections: 'No collecctions',
                    editcollection: 'Edit Collection',
                    collectionid: 'Collection id',
                    deletecollection: 'Delete collection',

                    collectionaddedsuccessfully: 'Collection is added successfully',
                    collectiondeletedsuccessfully: 'Collection is deleted successfully',
                    collectioneditedsuccessfully: 'Collection is edited successfully',
                    collectionlogoupdatesucess: 'Collection logo is updated successfully',
                    servererroraddingcollection: 'Error In Adding Collection. Please Contact Tabex Team',
                    servererroreditingcollection: 'Error in Editing Collection. Please Contact Tabex Team',
                    servererrorupdatecollectionlogo: 'Error in Updating Collection Logo. Please Contact Tabex Team',
                    itemisdeletedfromcollection: 'Product is removed from collection',
                    itemisaddedtocollection: 'Product is added to collection',

                    //customer
                    allcustomers: 'Customers',
                    addcustomer: 'Add Customer',
                    name: 'Name',
                    email: 'Email',
                    phonenumber: 'Phone Number',
                    orders: 'Orders',
                    state: 'State',
                    choosestate: 'choose state',
                    city: 'City',
                    choosecity: 'choose city',
                    country: 'Country',
                    choosecountry: 'choose country',
                    password: 'Password',
                    address: 'Address',
                    previousorders: 'Previous Orders',
                    orderid: 'Order ID',
                    items: 'Items',
                    total: 'Total',
                    status: 'Status',
                    nocustomers: 'No Customers',
                    editcustomer: 'Edit Customer',
                    deletecustomer: 'Delete Customer',
                    nocustomerfound: 'No customer found',
                    confirmorder: 'Confirm Order',

                    addcustomerservererror: 'Error in Adding Customer. Please Contact Tabex Team.',
                    editcustomerservererror: 'Error in Editing Customer. Please Contact Tabex Team.',
                    deletecustomerservererror: 'Error in Deleting Customer. Please Contact Tabex Team.',
                    customerhasbeensuccessfullyadded: 'Customer is added successfully ',
                    customerhasbeensuccessfullyedited: 'Customer information is edited Successfully ',
                    customerhasbeensuccessfullydeleted: 'Customer is deleted Successfully',
                    pleaseaddname: 'Please Add Name',

                    //header
                    logout: 'Logout',
                    english: 'English',
                    italian: 'Italian',
                    welcome: 'Welcome',

                    //home
                    engagement: 'Engagement',
                    thisday: 'This Day',
                    thisweek: 'This Week',
                    thismonth: 'This Month',
                    pending: 'Pending',

                    //orders
                    allorders: 'Orders',
                    orderstatus: 'Order Status',
                    fulfilment: 'Fulfilment',
                    paid: 'Paid',
                    delivered: 'Delivered',
                    fulfilled: 'Fulfilled',
                    unfulfilled: 'Unfulfilled',
                    unpaid: 'Unpaid',
                    shippingaddress: 'Shipping Address',
                    shippingnotes: 'Shipping Notes',
                    orderitems: 'Order Items',
                    quantity: 'Quantity',
                    delete: 'Delete',
                    ordersummary: 'Order Summary',
                    promocode: 'Promo Code',
                    remove: 'Remove',
                    paymentmethid: 'Payment Method',
                    cashondelivery: 'Cash on Delivery',
                    onlinepayment: 'Online Payment',
                    subtotal: 'Sub Total',
                    discount: 'Discount',
                    totalafterdiscount: 'Total after discount',
                    shipping: 'Shipping',
                    all: 'All',
                    addorder: 'Add Order',
                    noorders: 'No Orders',
                    visa: 'Visa',
                    cash: 'Cash',
                    return: 'Return',
                    order: 'Order',

                    //products
                    allproducts: 'Products',
                    addproduct: 'Add product',
                    collection: 'Collection',
                    salestatus: 'Sale Status',
                    hassale: 'Has Sale',
                    nosale: 'No Sale',
                    price: 'Price',
                    saleprice: 'Sale Price',
                    sku: 'SKU',
                    uploadproductimages: 'Upload Product Images',
                    uploadfiles: 'Upload Files',
                    choosenfiles: 'Choosen files',
                    pleaseremoveallunspportedfiles: 'Please remove all unsupported files.',
                    notavalidfiletype: 'Not Valied File Type',
                    limitedquantity: 'Limited Quantity',
                    alwaysavailable: 'Always Avaliable',
                    editproduct: 'Edit Product',
                    deleteproduct: 'Delete Product',
                    productavail: 'Product availability',
                    noproducts: 'No Products',
                    draft: 'Draft',
                    avaliability: 'Avaliability',
                    noimages: 'No images',
                    producttype: 'Product Type',
                    mothercategory: 'Mother Category',
                    collection: 'Collection',
                    suppliercode: 'Supplier Code',
                    suppliername: 'Supplier Name',
                    allowoutofstock: 'Allow out of stock',
                    dontallowoutofstock: "Don't allow out of stock",
                    issameretailpricealloutlets: 'Same retail prce in all outlets',
                    yes: 'Yes',
                    no: 'No',
                    profitmargin: 'Profit Margin',
                    profit: 'Profit',
                    allow: 'Allow',
                    dontallow: "Don't allow",
                    showroomstock: 'Show Room Stock',
                    warehousestock: 'Warehouse Stock',
                    incomingin: 'Incoming',
                    rwmatstatus: 'RWM status',

                    optionsupdatessuccess: 'Options Updated Successfully',
                    servererrorupdateoptions: 'Error in Updating Options. Please contact Tabex Team',
                    valuealreadyexists: 'Value already exists',
                    pleasewritevaluename: 'Please Write Value Name',
                    pleasewritevalues: 'Please Write Values',
                    pleasewriteoptionname: 'Please Write Option Name',
                    productaddedsuccess: 'Product is added successfully',
                    servererroraddingproduct: 'Error in Adding Product. Please contact Tabex Team',
                    optionsupdatedsuccess: 'Product Options updated successfully',
                    servererroroptionsupdated: 'Error. Please Contact Tabex Team ',
                    deleteproductsuccess: 'Product is Deleted',
                    servererrordeleteproduct: 'Error in Deleting Product. Please contact Tabex Team',
                    errorupdateproduct: 'Error In Updating Product Information',
                    galleryimagedeletedsuccess: 'Image is deleted Successfully',
                    servererrordeletegalleryimage: 'Error in Deleting Image. Please Contact Tabex Team',
                    defaultimageupdatedsuccess: 'Default Image is Updated',
                    servererrorupdatedefaultimage: 'Error in Updating Default Image. Please Contact Tabex Team',
                    prodinfoupdatessuccess: 'Product Information is Updated Successfully',
                    servererrorupdateprodinfo: 'Error in Updating Product Information. Please Contact Tabex Team',

                    //promocode
                    allpromocodes: 'Promo Codes',
                    addpromocode: 'Add promocode',
                    editpromocode: 'Edit promocode',
                    deletepromocode: 'Delete promocode',
                    promocodename: 'Promo Code Name',
                    type: 'Type',
                    usages: 'Usages',
                    expirationdate: 'Expiration Date',
                    active: 'Active',
                    inactive: 'Inactive',
                    totaltobeused: 'Total To Be Used',
                    totaltobeusedbyeachcustomer: 'Total To Be Used By Each Customer',
                    usedby: 'Used By',
                    customersandguests: 'Customers and Guests',
                    customersonly: 'Customers Only',
                    percentage: 'Percentage',
                    value: 'Value',
                    nopromocodes: 'No Promocodes',

                    serveraddpromocodeerror: 'Error in Adding coupon, Please Contact Tabex Team.',
                    servereditpromocodeerror: 'Error in Editing coupon, Please Contact Tabex Team.',
                    serverdeletepromocodeerror: 'Error in Deleting coupon, Please Contact Tabex Team.',
                    couponaddedsuccess: 'Coupon is added successfully',
                    couponeditedsuccess: 'Coupon is edited successfully',
                    coupondeletedsucess: 'Coupon is deleted',
                    pleasecompletethemissingfields: 'Please Complete The Missing Fields',
                    thisproductalreadyexists: 'This Product Already Exists',

                    //users
                    allusers: 'Users',
                    adduser: 'Add User',
                    edituser: 'Edit User',
                    securitygroup: 'Security Group',
                    choosesecuritygroup: 'Choose Security Group',
                    nousersfound: 'No Users Found',
                    deleteuser: 'Delete User',

                    servererroraddinguser: 'Error in Adding User. Please Contact Tabex Team',
                    servererroreditinguser: 'Error in Editing User. Please Contact Tabex Team',
                    servererrordeletinguser: 'Error in Deleting User. Please Contact Tabex Team',
                    usereditedsuccess: 'User is edited successfully',
                    useraddedsuccess: 'User is add successfully',
                    userdeletedsuccess: 'User is deleted successfully',

                    //securitylayers
                    securitylayers: 'Security Layers',
                    totalusers: 'Total Users',
                    addsecuritylayer: 'Add Security Layer',
                    securitygroupname: 'Security Group Name',
                    nosecuritylayers: 'No Security Layers',
                    pleaseaddsecuritygroupname: 'Please Add Security Group Name',
                    securitygpupdatedsuccess: 'Security Groups Updated Successfully',
                    servererrorupdatesecuritygp: 'Error In Updating Security Groups. Please Context Tabex Team',
                    edit: 'Edit',
                    nosecuritygroups: 'No Security Groups',
                    editsecuritylayer: 'Edit Security Layer',

                    //branches
                    branches: 'Branches',
                    addbranch: 'Add Branch',
                    editbranch: 'Edit Branch',
                    deletebranch: 'Delet Branch',
                    branchname: 'Branch Name',
                    createdon: 'Created On',
                    nobranches: 'No Branches',

                    brancheditedsuccess: 'Branch is edited successfully',
                    branchaddessuccess: 'Branch is added successfully',
                    branchdeleted: 'Branch is deleted successfully',
                    errorinaddingbranchserver: 'Error in Adding Branch. Please Contact Tabex Team',
                    erroreditingbranchserver: 'Error in Editing Branch. Please Contact Tabex Team',
                    errordeletingbranchserver: 'Error in Deleting Branch. Please Contact Tabex Team',

                    clear: 'clear',

                    exchange: 'Exchange',
                    refund: 'Refund',
                    trans: 'Transfer',
                    inventory: 'Inventory',
                    onlineout: 'Online/Out',
                    moneyinout: 'Money In/Out',
                },
                ar: {
                    choose: 'Choose',
                },
            },
            langdetect: '',
            setlang: this.setlang,
        };
    }

    setlang = (key) => {
        const cookies = new Cookies();
        cookies.set('sitelang', key, { path: '/' });
        this.setState({
            langdetect: key,
        });
        window.location.reload();
    };

    componentDidMount() {
        const cookies = new Cookies();
        var lastlangselected = cookies.get('sitelang');
        if (lastlangselected == 'en') {
            this.setState({
                langdetect: 'en',
            });
        } else if (lastlangselected == 'ar') {
            this.setState({
                langdetect: 'en',
            });
            document.body.setAttribute('dir', 'rtl');
        } else {
            this.setState({
                langdetect: 'en',
            });
            document.body.setAttribute('dir', 'rtl');
            this.setlang('en');
        }
    }

    render() {
        var setlang = this.state.setlang;
        var lang = '';

        if (this.state.langdetect == 'en') {
            lang = this.state.lang.en;
            document.body.setAttribute('dir', 'ltr');
        } else if (this.state.langdetect == 'ar') {
            lang = this.state.lang.ar;
            document.body.setAttribute('dir', 'rtl');
        } else {
            lang = this.state.lang.ar;
            document.body.setAttribute('dir', 'rtl');
        }

        var langdetect = this.state.langdetect;
        return <LanguageContext.Provider value={{ lang, setlang, langdetect }}>{this.props.children}</LanguageContext.Provider>;
    }
}

export const LanguageContextConsumer = LanguageContext.Consumer;
